document.addEventListener('DOMContentLoaded', function(){
    setTimeout(removeOptions, 1000);
    function removeOptions() {
        const judgeMeReviews = document.querySelector('#judgeme_product_reviews');
        if (judgeMeReviews) {
            const select = judgeMeReviews.querySelector('.jdgm-sort-dropdown');
            const hideValues = ['with-pictures', 'videos-first', 'most-helpful'];
            for (const option of select.options) {
                if (hideValues.includes(option.value)) {
                    option.remove();
                }
            }
        }
    }
})
